import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, withCtx as _withCtx, toDisplayString as _toDisplayString, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-135d7cdc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "block container-box" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "block-title container-title" }, "报案理赔", -1))
const _hoisted_3 = { class: "block-head" }
const _hoisted_4 = { class: "block-search" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "el-icon el-icon-plus" }, null, -1))
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" 新增报案 ")
const _hoisted_7 = [
  _hoisted_5,
  _hoisted_6
]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "line" }, null, -1))
const _hoisted_9 = { class: "table" }
const _hoisted_10 = { class: "row" }
const _hoisted_11 = ["href"]
const _hoisted_12 = { key: 1 }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "dot dot-yellow" }, null, -1))
const _hoisted_15 = { key: 1 }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "dot dot-green" }, null, -1))
const _hoisted_17 = { key: 2 }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "dot dot-grey" }, null, -1))
const _hoisted_19 = { class: "row" }
const _hoisted_20 = ["onClick"]
const _hoisted_21 = ["onClick"]
const _hoisted_22 = {
  key: 0,
  class: "activity"
}
const _hoisted_23 = { class: "activity-box" }
const _hoisted_24 = {
  key: 0,
  src: "https://oss.openinsu.com/jishibao/admin/20250613/17fa0f936850404435a313d56a57861f.png",
  class: "activity-img"
}
const _hoisted_25 = {
  key: 1,
  src: "https://oss.openinsu.com/anxinyouxuan/upload/20240625/9208d0c0ff013ca6d69aba43b2089383.png",
  class: "activity-img"
}
const _hoisted_26 = { style: {"width":"100%","text-align":"center"} }
const _hoisted_27 = /*#__PURE__*/_createTextVNode(" 我已知晓 ")
const _hoisted_28 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_el_input, {
            modelValue: _ctx.searchValue,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchValue) = $event)),
            placeholder: "请输入出险姓名或身份证号",
            style: {"margin":"0"}
          }, null, 8, ["modelValue"]),
          _createElementVNode("button", {
            class: "btn btn-alone",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.search && _ctx.search(...args)))
          }, " 搜 索 "),
          _createElementVNode("button", {
            class: "btn-white btn-alone",
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onReset && _ctx.onReset(...args)))
          }, " 重 置 ")
        ]),
        _createElementVNode("button", {
          class: "btn btn-alone",
          style: {"width":"106px"},
          onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onAdd && _ctx.onAdd(...args)))
        }, _hoisted_7)
      ]),
      _hoisted_8,
      _createElementVNode("div", _hoisted_9, [
        _createVNode(_component_el_table, {
          data: _ctx.tableData,
          style: {"width":"100%"},
          "header-cell-class-name": "table-head",
          "row-style": { color: '#5E617D' }
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              prop: "employee.name",
              fixed: "",
              label: "出险人"
            }),
            _createVNode(_component_el_table_column, {
              prop: "employee.idcard",
              label: "身份证号",
              width: "210"
            }),
            _createVNode(_component_el_table_column, {
              prop: "type",
              label: "方案类型"
            }),
            _createVNode(_component_el_table_column, {
              prop: "case_date",
              label: "出险日期"
            }),
            _createVNode(_component_el_table_column, {
              prop: "address",
              label: "出险地点"
            }),
            (_ctx.hasAppFeature('caseDirector'))
              ? (_openBlock(), _createBlock(_component_el_table_column, {
                  key: 0,
                  prop: "director",
                  label: "负责人"
                }))
              : _createCommentVNode("", true),
            _createVNode(_component_el_table_column, {
              prop: "address",
              label: "理赔材料"
            }, {
              default: _withCtx((scope) => [
                _createElementVNode("div", _hoisted_10, [
                  (scope.row.report_file)
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 0,
                        class: "link",
                        href: scope.row.report_file,
                        target: "_blank"
                      }, " 下载 ", 8, _hoisted_11))
                    : (_openBlock(), _createElementBlock("span", _hoisted_12, "-"))
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              prop: "status",
              "column-key": "date",
              label: "状态"
            }, {
              default: _withCtx((scope) => [
                (scope.row.status == '待受理')
                  ? (_openBlock(), _createElementBlock("p", _hoisted_13, [
                      _hoisted_14,
                      _createTextVNode(_toDisplayString(scope.row.status), 1)
                    ]))
                  : (scope.row.status == '处理中')
                    ? (_openBlock(), _createElementBlock("p", _hoisted_15, [
                        _hoisted_16,
                        _createTextVNode(_toDisplayString(scope.row.status), 1)
                      ]))
                    : (_openBlock(), _createElementBlock("p", _hoisted_17, [
                        _hoisted_18,
                        _createTextVNode(_toDisplayString(scope.row.status), 1)
                      ]))
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              fixed: "right",
              label: "操作"
            }, {
              default: _withCtx((scope) => [
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("span", {
                    class: "link",
                    onClick: ($event: any) => (_ctx.$router.push({path:'/report/detail/' + scope.row.report_id}))
                  }, "查看详情", 8, _hoisted_20),
                  (['待受理', '处理中'].includes(scope.row.status))
                    ? (_openBlock(), _createElementBlock("span", {
                        key: 0,
                        class: "link",
                        onClick: ($event: any) => (_ctx.revoke(scope.row.report_id))
                      }, "撤销", 8, _hoisted_21))
                    : _createCommentVNode("", true)
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["data"]),
        _createVNode(_component_el_pagination, {
          class: "pagination",
          currentPage: _ctx.pageNum,
          "onUpdate:currentPage": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.pageNum) = $event)),
          "page-size": _ctx.pageSize,
          "onUpdate:page-size": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.pageSize) = $event)),
          "page-sizes": [10, 30, 50, 100],
          layout: "total, sizes, prev, pager, next, jumper",
          total: _ctx.total,
          onSizeChange: _ctx.handleSizeChange,
          onCurrentChange: _ctx.handleCurrentChange
        }, null, 8, ["currentPage", "page-size", "total", "onSizeChange", "onCurrentChange"])
      ])
    ]),
    (_ctx.showWarning)
      ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
          _createElementVNode("div", _hoisted_23, [
            (_ctx.hasAppFeature('jsbActivityImage'))
              ? (_openBlock(), _createElementBlock("img", _hoisted_24))
              : (_openBlock(), _createElementBlock("img", _hoisted_25)),
            _createElementVNode("div", _hoisted_26, [
              _createElementVNode("button", {
                class: "btn know",
                onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.addInfo()))
              }, [
                _hoisted_27,
                (_ctx.downTime)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_28, "（" + _toDisplayString(_ctx.downTime) + "）", 1))
                  : _createCommentVNode("", true)
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}